import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const runSupportV2Reconcile = {
  name: "runSupportV2Reconcile" as const,
  input: z
    .object({
      teamId: zExt.objectId(),
      dryRun: z.boolean(),
      closeV2Only: z.boolean().optional(),
      dedupeOpen: z.boolean().optional(),
      matchVoice: z.boolean().optional(),
    })
    .strict(),
  output: z.object({ workflowId: z.string() }),
};
